import { Box } from "@material-ui/core";
import React from "react";

import { ProductHistoryFilter } from "../../../product_history/ui/components/product_history_filter";
import { ClientHistoryList } from "../components/client_history_list";

export const ClientHistoryListPage: React.FC = () => {
  return (
    <div>
      <Box mb={5}></Box>

      <ProductHistoryFilter />

      <Box mb={2}></Box>

      <ClientHistoryList />
    </div>
  );
};
